import request from "@/utils/request";

export function getById(id) {
    return request({
        url: "/cloud/announcementEntity/" + id,
        method: "get"
    });
}

export function lastList(limit) {
    return request({
        url: "/cloud/announcementEntity/lastList?limit=" + limit,
        method: "get"
    });
}

export function getPagesByCondition(data) {
    return request({
        url: "/cloud/announcementEntity/getPagesByCondition",
        method: "post",
        data: data,
    });
}

export function add(data) {
    return request({
        url: "/cloud/announcementEntity/add",
        method: "post",
        data: data,
    });
}

export function update(data) {
    return request({
        url: "/cloud/announcementEntity/update",
        method: "post",
        data: data,
    });
}

export function updateStatus(data) {
    return request({
        url: "/cloud/announcementEntity/updateStatus",
        method: "post",
        data: data,
    });
}

export function del(id) {
    return request({
        url: "/cloud/announcementEntity/del/" + id,
        method: "post"
    });
}